import { Directive, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";

const REFRESH_INTERVAL = 30;

@Directive({
  selector: "[countTo]",
})
export class CountToDirective implements OnInit, OnDestroy {
  @Input()
  public countTo: number;

  @Input("countToDuration")
  public duration: number;

  private step: number;
  private steps: number;
  private timeoutId: number;
  private increment: number;
  private num: number;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  public ngOnInit(): void {
    this.init();
    this.tick();
  }

  public ngOnDestroy(): void {
    this.clearTimeout();
  }

  private init(): void {
    this.step = 0;
    this.steps = Math.ceil(this.duration / REFRESH_INTERVAL);
    this.increment = this.countTo / this.steps;
    this.num = 0;
    this.setTextContent();
  }

  private tick(): void {
    this.timeoutId = window.setTimeoutOutsideAngular(() => {
      this.num += this.increment;
      this.step++;

      if (this.step >= this.steps) {
        this.clearTimeout();
        this.num = this.countTo;
        this.setTextContent();
      } else {
        this.setTextContent();
        this.tick();
      }
    }, REFRESH_INTERVAL);
  }

  private clearTimeout(): void {
    if (this.timeoutId) {
      window.clearTimeoutOutsideAngular(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private setTextContent(): void {
    this.elementRef.nativeElement.textContent = Math.round(this.num).toString();
  }
}
